export interface Paging {
    pageNo: number, 
    pageSize: number
}

export const defaultPaging: Paging = {
    pageNo: 1,
    pageSize: 20,
}
